import React from "react";
import { Card, Grid2 } from "@mui/material";
import { Company } from "../../interfaces/entities/company";
import { Link } from "react-router-dom";
import { Collection } from "../../enums/collections.enum";
import * as S from "./companyListView.styles";
import { Phone } from "@mui/icons-material";

interface CompanyListViewProps {
  companies: Company[] | undefined;
}

export const CompanyList: React.FC<CompanyListViewProps> = ({ companies }) => {

  if (!companies || companies.length === 0) return <div>No Companies Found</div>;

  return (
    <>
      {<Grid2 container spacing={2} sx={{ padding: 2 }} >
        {companies.map((company) => (
          <Grid2 key={company.id} size={{ xs: 12, sm: 6, md: 4 }}>
            <Card elevation={2} sx={{ background: 'transparent' }}>
              <Link to={`/${Collection.Companies}/${company.id}`} style={{ display: "flex", textDecoration: "none", width: "100%", height: '150px' }}>

                <S.BranchImageWrapper>
                  <S.BranchImage
                    src={company.image || "/assets/default-branch.jpg"}
                    alt={company.name}
                  />
                </S.BranchImageWrapper>

                {/* Branch Info */}
                <S.BranchInfo sx={{ background: '#FFFFFF20' }}>
                  <S.BranchName variant="h6">
                    {company.name}
                  </S.BranchName>
                  {/* <S.BranchMetaFirst variant="body2">
                    <LocationOnIcon sx={{ fontSize: 16, mr: 0.5, color: "#666" }} />
                    {branch.address || "Address not available"}
                  </S.BranchMetaFirst> */}
                  <S.BranchMeta variant="body2">
                    <Phone sx={{ fontSize: 16, mr: 0.5, color: "#666" }} />
                    {company.contact || "Not available"}
                  </S.BranchMeta>
                  <S.BranchMeta variant="body2">
                    {/* <Email sx={{ fontSize: 16, mr: 0.5, color: "#666" }} /> */}
                    {company.email || "Not available"}
                  </S.BranchMeta>
                </S.BranchInfo>
              </Link>
            </Card>
          </Grid2>
        ))}
      </Grid2>}
    </>
  );
};

